/**
 * Verifies that a property exists in client app config and has a valid value.
 */
export function isValidClientAppConfigProperty(config, property) {
  if (property in config) {
    return config[property] !== undefined && config[property] !== null && config[property] !== '';
  }
  return false;
}
//# sourceMappingURL=isValidClientAppConfigProperty.js.map